module.exports = __webpack_public_path__ + "static/media/connect-blue.82deffca.svg";